export default "__VITE_ASSET__Tw5ASoHW__"